import type { HRModule } from '@bc-library/interface'

export const HR_SETTING_ACCESS_KEYS = [
  'settingsDepartureCategoryAccess',
  'settingsDegreeFieldCategoryAccess',
  'settingsEmployeeVariablesAccess',
  'settingsStatusAccess',
  'settingsContractSuperTypesAccess',
  'settingsContractTypesAccess',
  'settingsOnboardingProcessAccess',
  'settingsMailTemplatesAccess',
  'settingsFirmNewsAccess',
  'settingsSignatureTemplatesAccess',
  'settingsResourceCreationFieldsAccess',
] as const

export type HrSettingAccessKey = typeof HR_SETTING_ACCESS_KEYS[number]

export const hasAnyHrSettingsAccess = (hr?: HRModule) => {
  if (!hr)
    return false
  if (hr.settingsAccess)
    return true
  return HR_SETTING_ACCESS_KEYS.some(key => hr[key])
}

export const hasHrSettingAccess = (
  hr: HRModule | undefined,
  key: HrSettingAccessKey,
) => {
  if (!hr)
    return false
  if (hr.settingsAccess)
    return true
  return !!hr[key]
}
